{
  "name": "@htmlbricks/svelte-webcomponent",
  "private": true,
  "version": "0.76.5",
  "type": "module",
  "scripts": {
    "dev": "vite --open",
    "build": "vite build",
    "publish:wc": "node publish.ts",
    "build:wc": "node build.ts",
    "watch:wc": "node watch.ts",
    "preview": "vite preview",
    "check": "svelte-check --tsconfig ./tsconfig.app.json && tsc -p tsconfig.node.json",
    "release:patch": "npm version patch && git push && git push --tags && npm run build:wc && npm run publish:wc",
    "release:minor": "npm version minor && git push && git push --tags && npm run build:wc && npm run publish:wc",
    "release:major": "npm version major && git push && git push --tags && npm run build:wc && npm run publish:wc"
  },
  "devDependencies": {
    "@google-pay/button-element": "^3.2.1",
    "@paypal/paypal-js": "^9.5.0",
    "@sveltejs/vite-plugin-svelte": "^7.0.0",
    "@tsconfig/svelte": "^5.0.8",
    "@types/debounce": "^1.2.4",
    "@types/node": "^24.10.1",
    "@types/rgb-hex": "^3.0.0",
    "chart.js": "^4.5.1",
    "date-holidays": "^3.26.12",
    "dayjs": "^1.11.20",
    "hls.js": "^1.6.15",
    "html5-joystick-new": "^0.0.6",
    "ol": "^10.8.0",
    "perfect-freehand": "^1.2.3",
    "prettier": "^3.8.1",
    "rollup-plugin-terser": "^7.0.2",
    "sass-embedded": "^1.98.0",
    "simple-serverless-auth-client": "^0.0.6",
    "simple-webrtc-element": "^0.0.1",
    "simple-webrtc-element-whep": "^0.2.3",
    "style-to-object": "^1.0.14",
    "svelte": "^5.55.0",
    "svelte-check": "^4.4.5",
    "terser": "^5.46.1",
    "ts-json-schema-generator": "^2.9.0",
    "typescript": "^6.0.2",
    "vite": "^8.0.3"
  },
  "dependencies": {
    "@floating-ui/dom": "^1.7.6",
    "@popperjs/core": "^2.11.8",
    "debounce": "^3.0.0",
    "html-colors": "^0.0.6",
    "marked": "^17.0.5",
    "raphael": "^2.3.0",
    "rgb-hex": "^4.1.0",
    "wc-js-utils": "^0.5.4"
  }
}
